/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useState } from "react";
import Entry from "./Entry";
import { Icon } from "@sunwing/icons/dist/sunwing";
import { RCL } from "../RCL";
import styles from "./WebPush.module.scss";
import config from "../../app/config";

const InboxBell = ( { lang, inboxMessages, email }) => {
  const [isVisible, setIsVisible] = useState(false);

  const handleBlur = (event) => {
    if (!event.currentTarget.contains(event.relatedTarget)) {
      if (isVisible) {
        setIsVisible(false);
      }
    }
  }

  return (
    <div id="alert-notification" tabIndex='0' onBlur={handleBlur} className={styles.alertWrapper}>
        <a onClick={() => { if (inboxMessages?.count && inboxMessages?.count > 0) setIsVisible((prev) => !prev) }} 
          className={`${styles.alertNotification} ${config.isWestJetMode ? styles.alertNotification_vwq : ""}`}>
        {inboxMessages?.count > 0 && (<span className={styles.alertNotificationCount}>{inboxMessages?.count}</span>)}
        <span className={styles.alertNotificationCircle}><Icon name="email" className={styles.alertNotificationIcon}/></span>
      </a>
      {isVisible && (
        <div className={styles.notificationHub}>
          <div><RCL searchKey="messages" /></div>
          {inboxMessages &&
            inboxMessages.messages
            ?.sort((a, b) => ((a.startDateUtc !== null) && -a.startDateUtc.localeCompare(b.startDateUtc)))
            .slice(0,3).map((mes, index) => {
              return (
                <Entry
                  key={index}
                  lang={lang}
                  id={index}
                  message={mes}
                  email={email}
                />
            )}
          )}
        { (inboxMessages.count > 3) && (<a href={`/${lang}/InboxMessage?messageId=ViewAll&brand=${config.isWestJetMode ? "vwq" : "swg"}`} style={{color:"blue"}}><RCL searchKey="view-all" /></a>)}
        </div>
      )}
    </div>
  );
};

export default InboxBell;
